/* GENIMO collection SEO module (2026-10-10).
   - Intro: the full text is already in the HTML; CSS clamps it. This script only
     flips the clamp and keeps aria-expanded in sync. Whether the button shows is
     decided by CSS first (shown on mobile, hidden >=768px), so first paint has the
     final layout; the script then adds .is-clamped to the wrap when the text really
     is cut off (shows the button on desktop) or sets [hidden] when it fits (mobile).
   - Chips: marks the row as scrollable / scrolled-to-end so CSS can show the edge fade.
   - FAQ uses native <details>, so it needs no script.
   No dependency on theme JS. Safe to run twice (idempotent) and on section reloads. */
(function () {
  'use strict';

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  function initIntro(root) {
    var wrap = root.querySelector('[data-seo-intro-wrap]');
    var intro = root.querySelector('[data-seo-intro]');
    var btn = root.querySelector('[data-seo-toggle]');
    if (!wrap || !intro || !btn) return;
    var more = btn.getAttribute('data-label-more') || 'Read more';
    var less = btn.getAttribute('data-label-less') || 'Show less';

    function isOpen() { return btn.getAttribute('aria-expanded') === 'true'; }
    function refresh() {
      // the button is needed while expanded (to collapse) or when the clamp cuts text off
      var needed = isOpen() || intro.scrollHeight > intro.clientHeight + 1;
      wrap.classList.toggle('is-clamped', needed);
      btn.hidden = !needed;
    }
    function set(open) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      wrap.setAttribute('data-expanded', open ? 'true' : 'false');
      btn.textContent = open ? less : more;
    }
    btn.addEventListener('click', function () {
      var open = !isOpen();
      set(open);
      refresh();
      if (!open) {
        // collapsing can leave the reader below the intro; bring it back if so
        // keep it clear of the sticky header
        var r = wrap.getBoundingClientRect();
        var hd = document.querySelector('.t4s-section-header');
        var off = hd ? Math.max(0, hd.getBoundingClientRect().bottom) : 0;
        if (r.top < off) window.scrollBy({ top: r.top - off - 8 });
      }
    });
    set(false);
    refresh();
    window.addEventListener('resize', debounce(refresh, 150));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
  }

  function initChips(root) {
    var row = root.querySelector('[data-seo-chips]');
    if (!row) return;
    function refresh() {
      var over = row.scrollWidth > row.clientWidth + 1;
      row.toggleAttribute('data-overflow', over);
      row.toggleAttribute('data-at-end', !over || row.scrollLeft + row.clientWidth >= row.scrollWidth - 2);
    }
    row.addEventListener('scroll', refresh, { passive: true });
    // keyboard: bring an off-screen chip into the swipe row
    row.addEventListener('focusin', function (e) {
      if (e.target && e.target.scrollIntoView) e.target.scrollIntoView({ inline: 'nearest', block: 'nearest' });
    });
    window.addEventListener('resize', debounce(refresh, 150));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
    refresh();
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-seo-module]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (root.hasAttribute('data-seo-ready')) continue;
      root.setAttribute('data-seo-ready', '');
      initIntro(root);
      initChips(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  // theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
